module.exports = __webpack_public_path__ + "Faq_Header_new.99c9ae64.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/desktop/headers/Faq_Header_new.png
// module id = 4Rv2
// module chunks = 0